import { 
  PROFILE_SUCCESS, 
  PROFILE_ERROR, 
  EDIT_MODE_SUCCESS,
  EDIT_MODE_ERROR,
  EDIT_PROFILE,
  EDIT_PHOTO_SUCCESS,
  EDIT_PHOTO_FAIL,
  EDIT_PASSWORD_SUCCESS,
  EDIT_PASSWORD_FAIL,
  SHOW_LOADING,
  HIDE_LOADING
} from "./actionTypes"

const initialState = {
  error: "",
  success: "",
  loading: false  
}

const profile = (state = initialState, action) => {
  switch (action.type) {
    case EDIT_PROFILE:
      state = { ...state }
      break
    case PROFILE_SUCCESS:
      state = { ...state, success: action.payload }
      break
    case PROFILE_ERROR:
      state = { ...state, error: action.payload }
      break
    case EDIT_MODE_SUCCESS:
      return {
        ...state
      };
    case EDIT_MODE_ERROR:
      return {
        ...state,
        error: action.payload,
      };
      
    case EDIT_PHOTO_SUCCESS:
      state = { ...state, success: action.payload }
      break
    case EDIT_PHOTO_FAIL:
      state = { ...state, error: action.payload }
      break
    case EDIT_PASSWORD_SUCCESS:
      state = { ...state, success: action.payload }
      break
    case EDIT_PASSWORD_FAIL:
      state = { ...state, error: action.payload }
      break
    case SHOW_LOADING:
      return {
        ...state,
        loading: action.payload,
      }
    case HIDE_LOADING:
      return {
        ...state,
        loading: action.payload,
      }      
    default:
      state = { ...state }
      break
  }
  return state
}

export default profile
